import { FloorplanCard } from '../';
import styles from './FloorplansList.module.css';

export default function FloorplansList({ floorplans, onSelectPlan }) {
    if (!floorplans || floorplans.length === 0) {
        return (
            <div className={styles.emptyState}>
                <p>No floorplans available</p>
            </div>
        );
    }

    return (
        <div className={styles.grid}>
            {floorplans.map((plan) => (
                <FloorplanCard
                    key={plan.id}
                    image={plan.image}
                    homeType={plan.homeType}
                    planName={plan.planName}
                    beds={plan.beds}
                    baths={plan.baths}
                    garage={plan.garage}
                    sqft={plan.sqft}
                    stories={plan.stories}
                    onSelect={() => onSelectPlan(plan)}
                />
            ))}
        </div>
    );
}
